import { defineMessages } from "react-intl"


export const messages = defineMessages({

    "identifier": {
        id: "credit_memo.listing.filters.id_label",
        defaultMessage: "ID"
    },
    "created_at": {
        id: "credit_memo.listing.filters.date.created_at",
        defaultMessage: "Created date",
    },
    "captured_date": {
        id: "credit_memo.listing.filters.date.captured_date",
        defaultMessage: "Captured date",
    },
    "amount": {
        id: "credit_memo.listing.filters.amount",
        defaultMessage: "Amount",
    },
    "remaining_amount": {
        id: "credit_memo.listing.filters.remaining_amount",
        defaultMessage: "Remaining amount",
    },
    "refunded_amount": {
        id: "credit_memo.listing.filters.refunded_amount",
        defaultMessage: "Refunded amount",
    },
    "status": {
        id: "credit_memo.listing.filters.status",
        defaultMessage: "Status",
    },
    "notes": {
        id: "credit_memo.listing.filters.notes",
        defaultMessage: "Notes",
    },
    "most_used_filters": {
        id: "credit_memo.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },

    "advanced_filters": {
        id: "credit_memo.listing.headers.advanced_filters",
        defaultMessage: "Advanced filters",
    },
    "status_filter_placeholder": {
        id: "invoice.listing.status_filters_placeholder",
        defaultMessage: "Filter by status",
    },
    "is_archived": {
        id: "invoice.listing.filters.show_archived",
        defaultMessage: "Show archived",
    },
    "effective_date": {
        id: "invoice.listing.filters.date.effective_date",
        defaultMessage: "Effective date",
    },
    "payment_id": {
        id: "credit_memo.listing.filters.payment_id",
        defaultMessage: "Payment(s) ID(s)",
    },
    "created_from_payment_id" :{
        id: "credit_memo.listing.filters.created_from_payment_id",
        defaultMessage: "Created from payment ID",
    },
    "invoice_reference_id": {
        id: "credit_memo.listing.filters.invoice_reference_id",
        defaultMessage: "Invoice reference ID",
    },
    "quote_reference_id_keyword" : {
        id: "credit_memo.listing.filters.quote_reference_id_keyword",
        defaultMessage: "Quote reference ID keyword",
    },
    "order_reference_id": {
        id: "credit_memo.listing.filters.order_reference_id",
        defaultMessage: "Order reference ID",
    },
    "price_list_reference_id": {
        id: "credit_memo.listing.filters.price_list_reference_id",
        defaultMessage: "Pricelist reference ID",
    },
    "unique_external_id": {
        id: "credit_memo.listing.filters.unique_external_id",
        defaultMessage: "Unique external ID",
    },
    "credit_memo_reference_id": {
        id: "credit_memo.listing.filters.credit_memo_reference_id",
        defaultMessage: "Credit memo reference ID",
    },




})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/creditMemosFilters/message.ts